<template>
    <div class="relative bg-white pt-16 md:pb-32 overflow-hidden" id="picks">
        <div class="relative">
            <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
                <div class="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
                    <div>
                        <div>
                            <span class="h-12 w-12 rounded-md flex items-center justify-center bg-gray-800">
                                <CashIcon class="h-6 w-6 text-white" aria-hidden="true" />
                            </span>
                        </div>
                        <div class="mt-6">
                            <h2 class="text-3xl font-extrabold tracking-tight text-gray-900">
                                Enter Your Picks
                            </h2>
                            <p class="mt-4 text-lg text-gray-500">
                                Select the meeting or meetings you want to participate in. Confirm your horse selections and apply a booster if desired. Once you've locked in your entry, you'll have a chance to win fantastic prizes.
                            </p>
                            <div class="mt-6">
                                <a href="/register" class="inline-flex px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-gray-800 hover:bg-gray-700">
                                    Sign Up
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-12 sm:mt-16 lg:mt-0 col-start-2">
                    <div class="flex justify-center lg:pl-4 lg:-mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
                        <img class="flex shrink-0 justify-center w-1/2 rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-auto lg:w-3/4 lg:max-w-none" :src="asset('images/entry.png')" alt="Purchasing tokens" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import { CashIcon, SparklesIcon } from '@heroicons/vue/outline'

	export default {
		components: {
			CashIcon,
			SparklesIcon,
		}
	}
</script>
